// extracted by mini-css-extract-plugin
module.exports = {"urlImg":"\"https://cdn-h5-html.gwmcloud.com/pcstore/\"","testUrlImg":"\"https://cdn-h5-html-test.gwmcloud.com/pcstore/\""};